t = require('views/internal/teacup-with-helpers')('board_menu_vis')
ldclient = require 'lib/ldclient'

module.exports = t.renderable ({ current, isNewBoard, canChange, mustChange,
  hasSuperAdmins, hasOrg, orgName, privateRestricted, orgRestricted,
  publicRestricted, hasCompany, companyName }) ->

  if mustChange && orgName
    t.p '.quiet', ->
      t.format 'illegal org visibility', { orgName }
  orgLevel = if hasCompany
    'with enterprise'
  else if hasSuperAdmins
    'with super admins'
  else if hasOrg
    'with organization'
  else
    'without organization'

  permissionLevels =
    'private':
      iconClass: 'icon-private'
      restricted: privateRestricted
    'org':
      iconClass: 'icon-organization'
      restricted: orgRestricted
      invalid: isNewBoard && !hasOrg
    'company':
      iconClass: 'icon-enterprise-dashboard'
      noCompany: !hasCompany
      invalid: isNewBoard && !hasOrg
    'public':
      iconClass: 'icon-public'
      restricted: publicRestricted
  if !ldclient.variation('enterprise.company_visible_boards', false)
    delete permissionLevels['company']


  for permissionLevel, { restricted, invalid, iconClass, noCompany } of permissionLevels
    t.li ->
      disabled = restricted || invalid || !canChange || noCompany
      t.a '.js-select', { class: t.classify('light-hover': !disabled, 'disabled': disabled), href: '#', name: permissionLevel }, ->
        t.span '.icon-sm.vis-icon', { class: iconClass }, ->
        t.check current == permissionLevel, permissionLevel
        t.span '.sub-name', ->
          args = if companyName
            { companyName, orgName }
          else if orgName
            { orgName }
          else
            {}

          t.format ['permission subtext', orgLevel, permissionLevel], args

          if canChange && restricted
            t.raw ' '
            t.span '.error', ->
              if isNewBoard
                t.format ['illegal visibility', 'create']
              else
                t.format ['illegal visibility', 'change']



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_menu_vis.coffee